export default __webpack_public_path__ + "static/media/entradas.67e2be2e.svg";